'use client'
import { useCompareStore } from '@/store'
import Image from 'next/image'
import Link from '@/features/ref/components/Link'
import Badge from '@mui/material/Badge'

export const CompareHeader = () => {
  const { count } = useCompareStore()
  return (
    // <Link href="/compare">
    <Badge badgeContent={count} color="primary" component={'a'} href="/compare">
      <Image src="/assets/images/ico_refresh.svg" alt="So sánh sản phẩm" width={30} height={30} />
    </Badge>
    // </Link>
  )
}
